// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BU5f","input":"styles_input__3g1f_"};